import React from 'react';
import indexRoutes from './routes/';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import RequireNotAuth from './hoc/RequireNotAuth';
import LandingLayout from './layouts/landingLayout'
import Blanklayout from './layouts/blanklayout';
import { NavigationTracker } from './utils/formReturn';

const App = () => (
    <Provider store={configureStore()}>
        <Router basename="/">
          <React.Fragment>
            {/* Where each add / edit form returns to after a Save (utils/formReturn) */}
            <NavigationTracker />
            <Switch>
                
                {/* {
                    indexRoutes.map((prop, key) => {
                        return <Route path={prop.path} key={key} component={prop.component} />;
                        // return <Route
                        //     {...rest}
                        //     render={props =>
                        //     isAuthenticated ? (
                        //         <Component {...props} />
                        //     ) : (
                        //         <Redirect to="/" />
                        //     )
                        //     }   
                        // />;
                    })
                } */}
                <Route path="/authentication" component = {Blanklayout}/>
                <Route path="/" component= {RequireNotAuth(LandingLayout)} />
            </Switch>
          </React.Fragment>
        </Router>
    </Provider>
);

export default App;